const _excluded = ["error", "helperText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Controller, useForm } from 'react-hook-form';
import { Box, ConfirmationModal, TextField, useOverlayContext } from 'seagull';
import { useStoreActions } from "../../../contexts";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import styles from "./RenameAPIKeyModal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const RenameAPIKeyModal = _ref => {
  let {
    apiKey,
    dismissModal,
    getIsNameValid,
    refresh
  } = _ref;
  const overlayContext = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      apiKeyName: apiKey.name
    }
  });
  const onSubmit = handleSubmit(async _ref2 => {
    let {
      apiKeyName
    } = _ref2;
    try {
      await api.business.renameAPIKey({
        id: apiKey.id,
        newName: apiKeyName
      });
      await refresh();
      dismissModal();
    } catch (error) {
      overlayContext.showErrorToast('Failed to rename API key', 'rename-api-key-error');
    }
  });
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Rename API Key",
    "data-testid": "rename-api-key-modal",
    width: "640px",
    content: /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "apiKeyName",
      rules: {
        required: 'API key name is required',
        validate: value => {
          if (!value.trim()) return true;
          return getIsNameValid(value) || 'API key name already exists';
        }
      },
      render: props => {
        const _connectControllerToT = connectControllerToTextField(props),
          {
            error,
            helperText
          } = _connectControllerToT,
          rest = _objectWithoutProperties(_connectControllerToT, _excluded);
        return /*#__PURE__*/_jsx(Box, {
          className: styles.renameApiKeyModalContent,
          children: /*#__PURE__*/_jsx(TextField, _objectSpread({
            label: "API key name",
            testid: "api-key-name",
            autoFocus: true,
            error: error,
            helperText: helperText
          }, rest))
        });
      }
    }),
    primaryButtonLabel: "Rename",
    onPrimaryButtonClick: onSubmit,
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: dismissModal
  });
};